export class NotificationPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NotificationPolicyTypeEnum",
            "format": ""
        },
        {
            "name": "config",
            "baseName": "config",
            "type": "NotificationPolicyConfig",
            "format": ""
        },
        {
            "name": "notificationTypes",
            "baseName": "notificationTypes",
            "type": "Array<NotificationType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
export var NotificationPolicyTypeEnum;
(function (NotificationPolicyTypeEnum) {
    NotificationPolicyTypeEnum["Slack"] = "Slack";
    NotificationPolicyTypeEnum["Email"] = "Email";
    NotificationPolicyTypeEnum["Sns"] = "SNS";
    NotificationPolicyTypeEnum["Splunk"] = "Splunk";
    NotificationPolicyTypeEnum["Webhook"] = "Webhook";
    NotificationPolicyTypeEnum["ServiceNow"] = "ServiceNow";
})(NotificationPolicyTypeEnum || (NotificationPolicyTypeEnum = {}));
